import React, { Component} from 'react';
import PropTypes from 'prop-types';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { camelCase } from 'lodash';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import * as actions from '../store/actions/index';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FolderOpen from '@material-ui/icons/FolderOpen';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import Refresh from '@material-ui/icons/Refresh';
import IconButton from '@material-ui/core/IconButton';

const styles = theme => ({
    container: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
    },
    root: {
        marginBottom: '6px',
        width: '100%',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '300px',
      },
      button: {
        //margin: theme.spacing.unit,
      },
    card: {
        minWidth: 250,
        width: 400,
        height: 200,
        marginRight: 6,
        marginBottom: 6,
    
    },
    topLabel:{
        fontSize: 16,
    },
    helperText: {
        fontSize: 14,
    },
});

class UploadDocSingleFile extends Component  {
    constructor(props) {
        super(props);
    }
    state = {
        file: null,
        doc_name: 'award',
        filename: '',
        doc_type:'',

    }

    componentDidUpdate(){
        // if (this.props.uploaded){
        //     if(this.props.file){
        //         this.handleReset(null, this.props.file.file.name);
        //         this.props.SetFalseUploaded();
        //     }
        //     else{
        //         this.props.SetFalseUploaded();
        //     }
        // }
    }

    uploadFile = (event) => {
        let file = event.target.files[0];
       console.log('the file# : '+JSON.stringify(file.name) );
        if (file) {
          //let data = new FormData();
          //data.append(file.name, file);
          //console.log(this.props)
          
          let doc_name = this.state.doc_name;
          this.props.onAddFile(file, doc_name);
          this.setState({file: file, doc_name: doc_name, filename: file.name});

        //   if(this.props.file){
        //     this.handleReset(null, this.props.file.file.name);
        //   }  
         
          // axios.post('/files', data)...
        }
    }
    
    handleReset = (event) => {
        if(this.state.doc_name){
            this.props.onResetFile(this.state.doc_name);        
        }else{
            if(this.state.file){
                this.props.onResetFile(this.state.file.name);
            }
        }
        this.setState({
            file: null,
            doc_name: 'award',
        });
    }
    
    handleResetAll = () => {
        this.setState({
            file: null,
            doc_name: 'award',
        });
        this.props.toggleReset();
    }
    
    handleChange = prop => event => {
        this.setState({ [prop]: event.target.value });
    };

    componentDidUpdate(prevProps, prevState){
        if(this.props.reset){
            this.handleResetAll();
        }

    }

    render(){
        const { classes } = this.props;
        return (
            <div className={classes.root} style={{}}>
                <FormControl component='fieldset' className={classes.a}>
                <div className={classes.container}>
                        <div style={{margin: '16px 8px 8px 8px', textAlign: 'center'}}>
                            
                            <Button
                                variant="contained"
                                component="label"
                                color="primary"
                                style={{height: '30px', marginRight:'20px', width: '85px', fontSize: '10px'}}
                                // disabled={!this.state.doc_name}
                            >
                            <FolderOpen fontSize='small'/>
                                {this.context.t('Browse')}
                            <input
                                type="file"
                                style={{ display: "none" }}
                                onChange={this.uploadFile}
                            />
                            </Button>
                            {/* <IconButton >
                                <PhotoCamera color="primary" />
                            </IconButton>    */}
                            <Button
                                variant="contained"
                                onClick={this.handleReset}
                                color="primary"
                                style={{height: '30px', width: '75px', fontSize: '10px'}}
                            >
                                <Refresh fontSize='small'/>
                                {this.context.t('Reset')}
                            </Button>
                            
                        </div>  
                           
                    </div> 
                    <p> {this.state.filename+'     '}   </p>
                </FormControl>   
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        uploaded: state.uploadDocs.uploaded,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        SetFalseUploaded: () => dispatch(actions.SetFalseUploaded()),
    }
}

UploadDocSingleFile.contextTypes = {
    t: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UploadDocSingleFile));